import { render, staticRenderFns } from "./AdxHealth.vue?vue&type=template&id=795318c4&scoped=true"
import script from "./AdxHealth.vue?vue&type=script&lang=js"
export * from "./AdxHealth.vue?vue&type=script&lang=js"
import style0 from "./AdxHealth.vue?vue&type=style&index=0&id=795318c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795318c4",
  null
  
)

export default component.exports